var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_2145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2468 5.24684L18.7532 0.753161C18.2709 0.270923 17.6169 3.56612e-06 16.9349 0H2.57143C1.15125 0 0 1.15125 0 2.57143V21.4286C0 22.8488 1.15125 24 2.57143 24H21.4286C22.8488 24 24 22.8488 24 21.4286V7.06511C24 6.38312 23.7291 5.72907 23.2468 5.24684ZM14.5714 2.57143V6.85714H7.71429V2.57143H14.5714ZM21.1071 21.4286H2.89286C2.80761 21.4286 2.72585 21.3947 2.66557 21.3344C2.60529 21.2741 2.57143 21.1924 2.57143 21.1071V2.89286C2.57143 2.80761 2.60529 2.72585 2.66557 2.66557C2.72585 2.60529 2.80761 2.57143 2.89286 2.57143H5.14286V8.14286C5.14286 8.85295 5.71848 9.42857 6.42857 9.42857H15.8571C16.5672 9.42857 17.1429 8.85295 17.1429 8.14286V2.77939L21.3344 6.97098C21.3643 7.00083 21.388 7.03627 21.4041 7.07527C21.4203 7.11427 21.4286 7.15607 21.4286 7.19829V21.1071C21.4286 21.1924 21.3947 21.2741 21.3344 21.3344C21.2741 21.3947 21.1924 21.4286 21.1071 21.4286ZM12 10.7143C9.40055 10.7143 7.28571 12.8291 7.28571 15.4286C7.28571 18.028 9.40055 20.1429 12 20.1429C14.5994 20.1429 16.7143 18.028 16.7143 15.4286C16.7143 12.8291 14.5994 10.7143 12 10.7143ZM12 17.5714C10.8184 17.5714 9.85714 16.6101 9.85714 15.4286C9.85714 14.247 10.8184 13.2857 12 13.2857C13.1816 13.2857 14.1429 14.247 14.1429 15.4286C14.1429 16.6101 13.1816 17.5714 12 17.5714Z",
    fill: "#516362"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_2145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.1717523bf0d81d7acbc14ea83bd81045.svg";
export { ForwardRef as ReactComponent };